import blogUrl from 'helpers/blogUrl'
import React from 'react'
import { Post, PostInfo, RecentPosts, Posts } from 'style/Blog.style'

export default function PostSuggestions(props) {
  const { posts } = props

  if (!Array.isArray(posts) || !posts.length) return null

  return (
    <RecentPosts>
      <h3>ხშირად კითხულობენ</h3>
      <Posts>
        {posts.map(post => {
          return (
            <Post to={blogUrl(post.slug)} key={post.slug}>
              <img src={post.image} alt={post.title} />
              <PostInfo>
                <h2>{post.title}</h2>
                <p>{post.date}</p>
              </PostInfo>
            </Post>
          )
        })}
      </Posts>
    </RecentPosts>
  )
}
